export const internallinks = [
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-goteborg",
    title: "Tömma dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/koper-dodsbo-goteborg",
    title: "Köper dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-goteborg",
    title: "Uppköp dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-vaxjo",
    title: "Tömma dödsbo Växjö"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-vaxjo",
    title: "Sälja dödsbo Växjö"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-goteborg",
    title: "Sälja dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-goteborg",
    title: "Värdera dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/hjalp-dodsbo-goteborg",
    title: "Hjälp dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-goteborg",
    title: "Bortforsling dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-goteborg",
    title: "Dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-hisingen",
    title: "Värdera dödsbo Hisingen"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-hisingen",
    title: "Tömma dödsbo Hisingen"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-hisingen",
    title: "Sälja dödsbo Hisingen"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-hisingen",
    title: "Uppköp dödsbo Hisingen"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-hisingen",
    title: "Bortforsling dödsbo Hisingen"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-av-bohag",
    title: "Uppköp av bohag"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-av-dodsbo",
    title: "Uppköp av dödsbo"
  },
  {
    path: "https://trygga-dodsbon.com/roja-dodsbo-goteborg",
    title: "Röja dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/stada-dodsbo-goteborg",
    title: "Städa dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-kungsbacka",
    title: "Värdera dödsbo Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-partille",
    title: "Bortforsling dödsbo Partille"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-partille",
    title: "Sälja dödsbo Partille"
  },
  {
    path: "https://trygga-dodsbon.com/kopa-dodsbo-partille",
    title: "Köpa dödsbo Partille"
  },
  {
    path: "https://trygga-dodsbon.com/rojer-dodsbo-partille",
    title: "Röjer dödsbo Partille"
  },
  {
    path: "https://trygga-dodsbon.com/stada-dodsbo-partille",
    title: "Städa dödsbo Partille"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-partille",
    title: "Uppköp dödsbo Partille"
  },
  {
    path: "https://trygga-dodsbon.com/flyttstadning-trollhattan",
    title: "Flyttstädning Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-trollhattan",
    title: "Dödsbo Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-kopes-trollhattan",
    title: "Dödsbo köpes Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-trollhattan",
    title: "Bortforsling dödsbo Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-trollhattan",
    title: "Värdera dödsbo Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-trollhattan",
    title: "Sälja dödsbo Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-trollhattan",
    title: "Tömma dödsbo Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/stadning-av-dodsbo-trollhattan",
    title: "Städning av dödsbo Trollhättan"
  },
  {
    path: "https://trygga-dodsbon.com/flyttstadning-dodsbo-boras",
    title: "Flyttstädning dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/stadar-dodsbo-alingsas",
    title: "Städar dödsbo Alingsås"
  },
  {
    path: "https://trygga-dodsbon.com/koper-dodsbo-alingsas",
    title: "Köper dödsbo Alingsås"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-alingsas",
    title: "Tömma dödsbo Alingsås"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-alingsas",
    title: "Värdera dödsbo Alingsås"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-goteborg",
    title: "Sälja dödsbo Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com",
    title: "Dödsbo Göteborg"
  },
  {
    path: "https://tantrut-alltjanst.com/",
    title: "TantRut Alltjänst"
  },
  {
    path: "https://flyttstroms.com/",
    title: "Flyttströms Flyttfirma"
  },
  {
    path: "https://goteborgs-dodsbo.com/",
    title: "Pålitlig  Dödsbofirma"
  },
  {
    path: "https://goteborgs-dodsbo.com/",
    title: "Partners Dödsbofirma"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-alvesta",
    title: "Sälja dödsbo Alvesta"
  }
];

export const popularLinks = [
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-ulricehamn",
    title: "Värdera dödsbo Ulricehamn"
  },
  {
    path: "https://trygga-dodsbon.com/hjalp-dodsbo-ulricehamn",
    title: "Hjälp dödsbo Ulricehamn"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-ulricehamn",
    title: "Bortforsling dödsbo Ulricehamn"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-ulricehamn",
    title: "Sälja dödsbo Ulricehamn"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-ulricehamn",
    title: "Tömma dödsbo Ulricehamn"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-ulricehamn",
    title: "Uppköp dödsbo Ulricehamn"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-ale",
    title: "Uppköp dödsbo Ale"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-ale",
    title: "Bortforsling dödsbo Ale"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-ale",
    title: "Sälja dödsbo Ale"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-ale",
    title: "Värdera dödsbo Ale"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-molndal",
    title: "Tömma dödsbo Mölndal"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-molndal",
    title: "Bortforsling dödsbo Mölndal"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-firma-molndal",
    title: "Dödsbo firma Mölndal"
  },
  {
    path: "https://trygga-dodsbon.com/kopa-dodsbo-molndal",
    title: "Köpa dödsbo Mölndal"
  },
  {
    path: "https://trygga-dodsbon.com/roja-dodsbo-molndal",
    title: "Röja dödsbo Mölndal"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-molndal",
    title: "Sälja dödsbo Mölndal"
  },
  {
    path: "https://trygga-dodsbon.com/stada-dodsbo-molndal",
    title: "Städa dödsbo Mölndal"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-stenungsund",
    title: "Bortforsling dödsbo Stenungsund"
  },
  {
    path: "https://trygga-dodsbon.com/roja-dodsbo-stenungsund",
    title: "Röja dödsbo Stenungsund"
  },
  {
    path: "https://trygga-dodsbon.com/kopa-dodsbo-stenungsund",
    title: "Köpa dödsbo Stenungsund"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-stenungsund",
    title: "Sälja dödsbo Stenungsund"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-stenungsund",
    title: "Tömma dödsbo Stenungsund"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-stenungsund",
    title: "Värdera dödsbo Stenungsund"
  },
  {
    path: "https://trygga-dodsbon.com/tommer-lagenheter-boras",
    title: "Tommer lägenheter Borås"
  },
  {
    path: "https://trygga-dodsbon.com/slutstadning-dodsbo-boras",
    title: "Slutstädning dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-boras",
    title: "Sälja dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/kopa-dodsbo-boras",
    title: "Köpa dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/roja-dodsbo-boras",
    title: "Röja dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-boras",
    title: "Bortforsling dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-firma-boras",
    title: "Dödsbo firma Borås"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-tomning-boras",
    title: "Dödsbo tömning Borås"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-hus-kungsbacka",
    title: "Tömma hus Kungsbacka"
  },
  {
    title: "Jämförelsesajt återvinning",
    path: "https://www.recyclerapp.com/atervinning"
  },
  {
    title: "Jämförelsesajt - tömma dödsbon",
    path: "https://www.recyclerapp.com/tomma-dodsbo"
  },
  {
    title: "Jämförelsesajt - Dödsbo köpes",
    path: "https://www.recyclerapp.com/tomma-dodsbo"
  },
  {
    title: "Jämförelsesajt - Flyttfirma Göteborg",
    path: "https://www.recyclerapp.com/flyttfirma-goteborg"
  },
  {
    title: "Jämförelsesajt - Flyttfirma Stockholm",
    path: "https://www.recyclerapp.com/flyttfirma-stockholm"
  },
  {
    title: "Jämför & boka städfirmor",
    path: "https://www.recyclerapp.com/pages/stadning/stadfirma"
  },
  {
    title: "Bortforsling av möbler",
    path: "https://www.recyclerapp.com/bortforsling-mobler"
  },
  {
    title: "Hyra container jämför & boka",
    path: "https://www.recyclerapp.com/hyra-container"
  },
  {
    title: "Hyra sopkärl jämför & boka",
    path: "https://www.recyclerapp.com/karl"
  },
  {
    title: "Jämför flyttfirmor i Göteborg",
    path: "https://www.recyclerapp.com/flyttfirma-goteborg"
  },
  {
    title: "Jämför flyttfirmor i Stockholm",
    path: "https://www.recyclerapp.com/flyttfirma-stockholm"
  },
  {
    title: "Koppar kilopris",
    path: "recyclerapp.com/pages/skrotpriser/koppar/skrotpriser-koppar-kilopris"
  },
  {
    title: "Skrotpriser koppar",
    path: "recyclerapp.com/pages/skrotpriser/koppar/skrotpriser-koppar-kilopris"
  }
];

export const fleromrodenLinks = [
  {
    path: "https://trygga-dodsbon.com/flyttfirma/flyttfirma-goteborg",
    title: "Flyttfirma Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/flyttfirma/flyttfirma-kungalv",
    title: "Flyttfirma Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/flyttfirma/flyttfirma-boras",
    title: "Flyttfirma Borås"
  },
  {
    path: "https://trygga-dodsbon.com/flyttfirma/billig-flyttfirma-goteborg",
    title: "Billig flyttfirma Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/flyttfirma/flyttfirma-offert",
    title: "Flyttfirma Offert"
  },
  {
    path: "https://trygga-dodsbon.com/tommer-hushall",
    title: "Tömmer hushåll"
  },
  {
    path: "https://trygga-dodsbon.com/tommer-hem",
    title: "Tömmer hem"
  },
  {
    path: "https://trygga-dodsbon.com/tommer-hem-goteborg",
    title: "Tömmer hem i Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/tommer-hushall-goteborg",
    title: "Tömmer hushåll i Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-kungalv",
    title: "Värdera dödsbo Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/hjalp-dodsbo-kungalv",
    title: "Hjälp dödsbo Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-kungalv",
    title: "Bortforsling dödsbo Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-kungalv",
    title: "Sälja dödsbo Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-kungalv",
    title: "Tömma dödsbo Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-kungalv",
    title: "Uppköp dödsbo Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-frolunda",
    title: "Uppköp dödsbo Frölunda"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-frolunda",
    title: "Sälja dödsbo Frölunda"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-frolunda",
    title: "Tömma dödsbo Frölunda"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-frolunda",
    title: "Värdera dödsbo Frölunda"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-frolunda",
    title: "Bortforsling dödsbo Frölunda"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-uppkopare-goteborg",
    title: "Dödsbo uppköpare Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/tommer-dodsbo",
    title: "Tömmer dödsbo"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbofirma",
    title: "Dödsbo firma"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo",
    title: "Tömma Dödsbo"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-ale",
    title: "Tömma dödsbo Ale"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-uppkopare",
    title: "Dödsbo uppköpare"
  },
  {
    path: "https://trygga-dodsbon.com/foretag-som-koper-bohag",
    title: "Företag som köper bohag"
  },
  {
    path: "https://trygga-dodsbon.com/bortforsling-dodsbo-kungsbacka",
    title: "Bortforsling dödsbo Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/dodsbo-firma-kungsbacka",
    title: "Dödsbo firma Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/hamtar-dodsbo-kungsbacka",
    title: "Hämtar dödsbo Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/koper-dodsbo-kungsbacka",
    title: "Köper dödsbo Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/salja-dodsbo-kungsbacka",
    title: "Sälja dödsbo Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-kungsbacka",
    title: "Tömma dödsbo Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/tommer-dodsbo-kungsbacka",
    title: "Tömmer dödsbo Kungsbacka"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-boras",
    title: "Tömma dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo-boras",
    title: "Värdera dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/uppkop-dodsbo-boras",
    title: "Uppköp dödsbo Borås"
  },
  {
    path: "https://trygga-dodsbon.com/vardering-av-dodsbo",
    title: "Värdering av dödsbo"
  },
  {
    path: "https://trygga-dodsbon.com/flyttstadning",
    title: "Flyttstädning"
  },
  {
    path: "https://trygga-dodsbon.com/flyttstadning-i-goteborg",
    title: "Flyttstädning i Göteborg"
  },
  {
    path: "https://trygga-dodsbon.com/flyttstadning-i-kungalv",
    title: "Flyttstädning i Kungälv"
  },
  {
    path: "https://trygga-dodsbon.com/bohagsflytt",
    title: "Bohagsflytt"
  },
  {
    path: "https://trygga-dodsbon.com/vardera-dodsbo",
    title: "Värdera dödsbo"
  },
  {
    path: "https://trygga-dodsbon.com/tomma-dodsbo-alvesta",
    title: "Tömma dödsbo Alvesta"
  }
];
